/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeviceAllocationsDto } from './deviceAllocationsDto';
import { OrderItemConfigurationDto } from './orderItemConfigurationDto';
import { ArticleDto } from './articleDto';


export interface OrderItemDto { 
    amount?: number;
    articles?: Array<ArticleDto>;
    comment?: string;
    readonly deviceAllocations?: DeviceAllocationsDto;
    id?: number;
    index?: number;
    name?: string;
    orderItemConfigurations?: Array<OrderItemConfigurationDto>;
    reminderTimestamp?: string;
    status?: OrderItemDto.StatusEnum;
}
export namespace OrderItemDto {
    export const StatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


